import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {duotoneIconStyle} from 'src/utils/app-shell';
import {useHistory} from 'src/rerouter/index';
import {
  PageTitle,
  TabSlot,
  TabList,
  Tab,
  PageName,
  TitleMedium,
  Icon,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from './earnings.css';


const Earnings = ({children}: {children: React.ReactNode}) => {
  const {t} = useLabelTranslation();
  const router = useHistory();

  const earningsTabs = [
    {tabId: '/earnings/my-earnings', label: t('My_Earnings', 'My Earnings')},
    {
      tabId: '/earnings/payments',
      label: t('Payments_Method', 'Payments Method'),
    },
  ];

  const defaultSelectedTab = earningsTabs.find((tab) =>
    router.location.pathname.includes(tab.tabId),
  );

  return (
    <>
      <PageTitle>
        <PageName>
          <TitleMedium>{t('Earnings', 'Earnings')}</TitleMedium>
          <Icon type="duotone" name="wallet" style={duotoneIconStyle} />
        </PageName>
        <TabSlot className={css.tabSlot}>
          <TabList
            onSelect={(tab) => router.replace(tab.tabId)}
            size="medium"
            selectedTab={defaultSelectedTab}
          >
            {earningsTabs.map((tab) => (
              <Tab
                size="medium"
                key={tab.tabId}
                label={tab.label}
                tabId={tab.tabId}
              />
            ))}
          </TabList>
        </TabSlot>
      </PageTitle>

      <div className={css.children}>{children}</div>
    </>
  );
};

export default Earnings;
